import React, { useEffect, useRef } from 'react';

import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import Tab, { TabGroup as TabGroupLib } from '@amzn/meridian/tab';
import { setSelectedFormTab } from 'src/store/adminConfigPageSlice/adminConfigPageSlice';
import { AdminConfigNavConsts, AdminConfigTabMap } from 'src/store/adminConfigPageSlice/common/constants';
import { useAppSelector } from 'src/store/store';

// **** Components **** //

/**
 * Toggle the Task/TaskGroup Tables
 */
const RestrictionFormConfigurationTabGroup = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { selectedFormTab } = useAppSelector((state) => state.adminConfigPage);
  const { selectedRegion } = useAppSelector((state) => state.regionTasksConfigPage);
  const pauseSelectTabHook = useRef(false);

  const selectTab = (newTab: string) => {
    dispatch(setSelectedFormTab(newTab));
    const newPath = AdminConfigTabMap.FormConfig.get(newTab);
    pauseSelectTabHook.current = true;
    navigate(newPath, { replace: true });
  };

  // "Select-Tab-Hook" Set tab from URL, default to "Table" if none selected
  useEffect(() => {
    if (pauseSelectTabHook.current) return;
    const tab = AdminConfigTabMap.FormConfig.get(location.pathname);
    if (!!tab) {
      dispatch(setSelectedFormTab(tab));
    } else if (location.pathname === AdminConfigNavConsts.Form.root.PATH) {
      selectTab(AdminConfigNavConsts.Form.Table.TAB);
    }
  }, [location.pathname]);

  return (
    <TabGroupLib value={selectedFormTab} onChange={selectTab}>
      <Tab value={AdminConfigNavConsts.Form.Table.TAB}>Forms</Tab>
      {selectedRegion.id > 0 && <Tab value={AdminConfigNavConsts.Form.Edit.TAB}>{selectedRegion.name} Edit</Tab>}
    </TabGroupLib>
  );
};

// **** Export **** //

export default RestrictionFormConfigurationTabGroup;
